import type { ICPDState } from '../../types/redux/cpd';

const initialState: ICPDState = {
  cpdRegions: [],
  chatId: null,
};

export function cpdReducer(state: ICPDState = initialState) {
  return state;
}
